import { getLocale } from "../runtime";

const sv_displayingxofyproducts = /** @type {(inputs: {value: NonNullable<unknown>, total: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Visar ${inputs.value} av ${inputs.total} produkter`
};

const displayingxofyproducts = /** @type {(inputs: {value: NonNullable<unknown>, total: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_displayingxofyproducts(inputs)
	return "displayingXOfYProducts";
};

export { displayingxofyproducts as "displayingXOfYProducts" };